import(/* webpackMode: "eager" */ "/builds/entertainment-offical/ent-web-cli/src/app/layout.js");
